import { Textfit } from '@wwe-portal/ui/components/text-fit';

import { IcoMoonIcon } from '@wwe-portal/ui/components/icons';
import { ClickableDiv } from '@wwe-portal/ui/components/button';

export function Header({
  title,
  onClose,
}: {
  title: string;
  onClose?: () => void;
}) {
  return (
    <div className="bg-stretch bg-header-modal relative h-[50px] w-full">
      <div className="absolute inset-0 right-0 flex items-center">
        <Textfit
          className="font-akagi flex h-full w-full flex-1 items-center justify-center px-1 text-center italic text-white drop-shadow-[0px_4px_4px_rgba(0,0,0,0.25)]"
          max={20}
          mode="multi"
        >
          {title}
        </Textfit>
        {onClose ? (
          <ClickableDiv
            className="cursor-pointer p-[9px] transition-transform hover:scale-125 active:scale-75"
            onClick={onClose}
          >
            <IcoMoonIcon className="size-4" iconName="close" />
          </ClickableDiv>
        ) : null}
      </div>
    </div>
  );
}
